export default __webpack_public_path__ + "paper-push-pin.png";